"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineerAggregatorType = void 0;
var EngineerAggregatorType;
(function (EngineerAggregatorType) {
    EngineerAggregatorType[EngineerAggregatorType["ALL"] = 0] = "ALL";
    EngineerAggregatorType[EngineerAggregatorType["ENGINEER"] = 1] = "ENGINEER";
    EngineerAggregatorType[EngineerAggregatorType["REGION"] = 2] = "REGION";
    EngineerAggregatorType[EngineerAggregatorType["SKILL"] = 3] = "SKILL";
    EngineerAggregatorType[EngineerAggregatorType["TEAM"] = 4] = "TEAM";
})(EngineerAggregatorType || (exports.EngineerAggregatorType = EngineerAggregatorType = {}));
//# sourceMappingURL=EngineerAggregatorType.js.map